import React from "react"
import "./header.scss"

function Header() {

  return (
    <div className="brandHeader">
      <p>Pokedex</p>
    </div>
  );
}

export default Header;